import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteTagRequest = {
	id: number;
};

export const deleteTag = createDeleteEndpoint<DeleteTagRequest>(({ id }) => `/api/v3/core/tags/${id}`);
